<template>
  <ion-page id="boardpreferences-page">
    <ion-content>

      <div v-if="showState == SHOW_BOARD_COLORS">
        <SingleOption :displayArray="boardColorsOptionArray"
                        :descriptionHeading="boardColorsOptionHeading"
                        :initialSelected="boardColorsOptionSelected"
                        :wordsSpoken="boardColorsOptionWordsSpoken"
                        :wordsSpokenTrigger="boardColorsOptionWordsSpokenTrigger"

                        @item-selected="boardColorsOptionClick" 
                        @toolbar-click="boardColorsOptionToolbarClick"/>
      </div>

      <div v-if="showState == SHOW_COORDINATES ">
        <SingleOption :displayArray="coordinatesOptionArray"
                        :descriptionHeading="coordinatesOptionHeading"
                        :initialSelected="coordinatesOptionSelected"

                        :wordsSpoken="coordinatesOptionWordsSpoken"
                        :wordsSpokenTrigger="coordinatesOptionWordsSpokenTrigger"

                        @item-selected="coordinatesOptionClick" 
                        @toolbar-click="coordinatesOptionToolbarClick" />

      </div>

      <div v-if="showState == SHOW_FILEWORDS ">
        <SingleOption :displayArray="fileWordsOptionArray"
                        :descriptionHeading="fileWordsOptionHeading"
                        :initialSelected="fileWordsOptionSelected"

                        :wordsSpoken="fileWordsOptionWordsSpoken"
                        :wordsSpokenTrigger="fileWordsOptionWordsSpokenTrigger"

                        @item-selected="fileWordsOptionClick" 
                        @toolbar-click="fileWordsOptionToolbarClick" />
                        @item-selected="fileWordsOptionClick" />
      </div>

      <div v-if="showState == SHOW_EXPLAINTOUR">
          <ExplainTour :screen="explainTourScreen"
                  :wordsSpoken="explainTourWordsSpoken"
                  :wordsSpokenTrigger="explainTourWordsSpokenTrigger"
                @toolbar-click="explainTourToolbarClick" />
      </div>

      <div v-show="showState == SHOW_MENU">
        <TopLine :style="styleTopline" :title="boardPreferenceTitle" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

        <ion-list id="board-menu" :style="styleMiddle">

        <ion-item>
          <ion-label @click="onClick('list','boardcolors')">
            {{ translateEnglishWords("Board Colors") }}
            <div class="indent">{{ boardColorString }}</div>
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label @click="onClick('list','coordinates')">
             {{ translateEnglishWords("Board Coordinates") }}
            <div class="indent">{{ coordinateLocationString }}</div>
          </ion-label>
        </ion-item>

        <ion-item :key="fileWordString">
          <ion-label @click="onClick('list','filewords')">
             {{ translatePhrase("File Words - instead of letters") }}
            <div class="indent">{{ fileWordString }}</div>
          </ion-label>
        </ion-item>

      </ion-list>
      <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
    </div>
  </ion-content>
</ion-page>


</template>

<script setup>

  import { IonPage, IonContent,IonList,IonItem,IonLabel  } from '@ionic/vue';
  import { computed } from "@vue/reactivity"

  import { ref, watch } from 'vue'
  import ExplainTour from '@/components/ExplainTour.vue'
  import ToolBar from '@/components/ToolBar.vue'
  import TopLine from '@/components/TopLine.vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useGetData, generateErrorAlertText } from '../../composables/getData.js'
  import { parseWordsSaid , buildWordListFromChoiceList } from '@/composables/wordlistSupport.js'
  import SingleOption from '@/components/SingleOption.vue'

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, scrollElement,
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { translateEnglishWords,translatePhrase } from '@/composables/translation.js';

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
        wordsSaid : {
          type : String,
          default : ""
        },
        wordsSaidTrigger : {
          type : Number,
          default : 0
        }
      })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const dummyRef = ref(connectionStore.getDummy)
  const isDark = ref(connectionStore.getDarkmode != "light")
  const coordinate = ref(connectionStore.getCoordinateLocation)
  
  const wordlistTrigger = ref(0)

  const wordlistMenu = "command board coordinate coordinates explain ignore done colors color file words mute listen scroll down up";
  
  const wordlist = ref(wordlistMenu)
  emit("word-list",wordlist.value)

  const explainTourWordsSpoken = ref("")
  const explainTourScreen = ref("")
  const explainTourWordsSpokenTrigger = ref(0)

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

  const SHOW_MENU = 0
  const SHOW_EXPLAINTOUR = 1
  const SHOW_BOARD_COLORS = 2
  const SHOW_COORDINATES = 3
  const SHOW_FILEWORDS = 4
  
  const showState = ref(SHOW_MENU)

  const TOOLBAR_EXPLAIN = 1

  const toolbarElements = ref([
    { index : TOOLBAR_EXPLAIN, label : translateEnglishWords("Explain") ,disabled : false}
  ])
  const toolbarTrigger = ref(0)

  const boardPreferenceTitle = ref(translateEnglishWords("Board Preferences"))

  const boardColorString = ref(connectionStore.getBoardColors)
  const coordinateLocationString = ref(connectionStore.getCoordinateLocation)
  const fileWordString = ref(connectionStore.getFileWords)

  const boardColorsOptionHeading = ref("")
  const boardColorsOptionArray = ref([])
  var boardColorsOptionDisplayWordsArray = []
  var useboardColorsOptionDisplayWords = ""
  var boardColorsOptionServerField = ""
  const boardColorsOptionSelected = ref("")

  const boardColorsOptionWordsSpoken = ref("")
  const boardColorsOptionWordsSpokenTrigger = ref(0)

  const coordinatesOptionHeading = ref("Board Coordinate Location")
  const coordinatesOptionArray = ref([])
  var coordinatesOptionDisplayWordsArray = []
  var useCoordinatesOptionDisplayWords = ""
  var coordinatesOptionServerField = ""
  const coordinatesOptionSelected = ref("")

  const coordinatesOptionWordsSpoken = ref("")
  const coordinatesOptionWordsSpokenTrigger = ref(0)
  
  const fileWordsOptionHeading = ref("")
  const fileWordsOptionArray = ref([])
  var fileWordsOptionDisplayWordsArray = []
  var useFileWordsOptionDisplayWords = ""
  var fileWordsOptionServerField = ""
  const fileWordsOptionSelected = ref("")

  const fileWordsOptionWordsSpoken = ref("")
  const fileWordsOptionWordsSpokenTrigger = ref(0)

  setupCoordinates()
  setupBoardColors()
  setupFileWords()

  doStartupCheck(true,afterStartupCallbackRoutine)

   watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

   watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

  function afterStartupCallbackRoutine(stuffChanged) {
    dummyRef.value = connectionStore.getDummy
  }

  function onClick(clickType,option) {
    //console.log("################### Click ",clickType,option)

    if (clickType == 'route') {
      emit("where-next",option)

      //router.replace({ path: option })
      return
    }

    switch (option) {
      case "boardcolors" :
        doBoardColors();
        break;
      case "coordinates" :
        getCoordinateValueFromServer()
        break;
      case "filewords" :
        doFileWords();
        break;
    }
  }

  // START Explain Tour Routines

function explainTourInitialize(page,html) {
  showState.value = SHOW_EXPLAINTOUR
  explainTourScreen.value =  (page != null) ? page : html;
  wordlist.value = connectionStore.getExplainTourWords
  emit("word-list",wordlist.value)
  wordlistTrigger.value++
}

function explainTourToolbarClick(whatClicked) {
  switch (whatClicked) {

    case "mute" :
      microphoneIsMuted.value = true 
      emit("mic-is-muted",microphoneIsMuted.value)
      connectionStore.setMicrophoneIsMuted(true)
      break
    case "listen" :
      microphoneIsMuted.value = false 
      emit("mic-is-muted",microphoneIsMuted.value)
      connectionStore.setMicrophoneIsMuted(false)
      break
    case "done" :
      showState.value = SHOW_MENU
      wordlist.value = wordlistMenu
      emit("word-list",wordlist.value)
      wordlistTrigger.value++
      break
  }
}

// END Explain Tour Routines

function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  function boardColorsOptionToolbarClick(selected) {
    //console.log("boardcolors option toolbar click",selected)
    toolbarTrigger.value++
    switch (selected) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "explain" :
        explainTourInitialize("options_single",null)
        break
      case "done" :
        showState.value = SHOW_MENU
        wordlist.value = wordlistMenu
        emit("word-list",wordlist.value)
        wordlistTrigger.value++
        toolbarTrigger.value++
        break
    }
  }

  function setupBoardColors() {
    boardColorsOptionHeading.value = translateEnglishWords("Board Colors")
    boardColorsOptionArray.value = []
    boardColorsOptionDisplayWordsArray = []

    var oneDisplay = { index : 0, name : translateEnglishWords("1 - Chessvis Light"), id : "light",radio : "light", words:"one" }
    boardColorsOptionArray.value.push(oneDisplay)
    boardColorsOptionDisplayWordsArray.push(oneDisplay.words)
    oneDisplay = { index : 2, name : translateEnglishWords("2 - Chessvis Night"), id : "chessvis",radio : "chessvis", words:"two" }
    boardColorsOptionArray.value.push(oneDisplay) 
    boardColorsOptionDisplayWordsArray.push(oneDisplay.words)
    oneDisplay = { index : 3, name : translateEnglishWords("3 - Lichess Night"), id : "lichess",radio : "lichess" , words:"three"}
    boardColorsOptionArray.value.push(oneDisplay)
    boardColorsOptionDisplayWordsArray.push(oneDisplay.words)

    boardColorsOptionSelected.value = connectionStore.getBoardColors
    useboardColorsOptionDisplayWords = buildWordListFromChoiceList(boardColorsOptionDisplayWordsArray)
  
    for (var i=0; i < boardColorsOptionArray.value.length; i++)
      if (boardColorsOptionSelected.value == boardColorsOptionArray.value[i].radio) {
        boardColorString.value = boardColorsOptionArray.value[i].name
        break
      }
  }

  function doBoardColors() {
    //console.log("in do boardcolors")
    
    wordlist.value = useboardColorsOptionDisplayWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
    toolbarTrigger.value++
    showState.value = SHOW_BOARD_COLORS
  }

  function setupCoordinates() {
    coordinatesOptionArray.value = []
    coordinatesOptionDisplayWordsArray = []
    var oneDisplay = { index : 0, name : translateEnglishWords("Inside"), id : "in",radio : "in" , words : "inside"}
    coordinatesOptionArray.value.push(oneDisplay)
    coordinatesOptionDisplayWordsArray.push(oneDisplay.words)
    oneDisplay = { index : 1, name : translateEnglishWords("Outside"), id : "out",radio : "out" , words : "outside"}
    coordinatesOptionArray.value.push(oneDisplay)
    coordinatesOptionDisplayWordsArray.push(oneDisplay.words)
    oneDisplay = { index : 2, name : translateEnglishWords("None"), id : "none",radio : "none" , words : "none"}
    coordinatesOptionArray.value.push(oneDisplay) 
    coordinatesOptionDisplayWordsArray.push(oneDisplay.words)

    coordinatesOptionSelected.value = connectionStore.getCoordinateLocation
    useCoordinatesOptionDisplayWords = buildWordListFromChoiceList(coordinatesOptionDisplayWordsArray)
 
    for (var i=0; i < coordinatesOptionArray.value.length; i++)
      if (coordinatesOptionSelected.value == coordinatesOptionArray.value[i].radio) {
        coordinateLocationString.value = coordinatesOptionArray.value[i].name
        break
      }
  }

  function doCoordinates() {
    //console.log("in do coordinates")

    //console.log("****************** selected",coordinatesOptionSelected.value)
    //console.log("****************** single option array",coordinatesOptionArray.value)
    //console.log("****************** single option word list",useCoordinatesOptionDisplayWords)

    wordlist.value = useCoordinatesOptionDisplayWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
    toolbarTrigger.value++
    showState.value = SHOW_COORDINATES
  }

  function setupFileWords() {
    fileWordsOptionHeading.value = translateEnglishWords("Speak Words for File?")
    fileWordsOptionArray.value = []
    fileWordsOptionDisplayWordsArray = []
    var oneDisplay = { index : 0, name : translateEnglishWords("Words") + ": Alpha, Bravo, ...", id : "words",radio : "words" , words : "words"}
    fileWordsOptionArray.value.push(oneDisplay)
    fileWordsOptionDisplayWordsArray.push(oneDisplay.words)
    oneDisplay = { index : 1, name : translateEnglishWords("Names") + ": Anna, Bella, ...", id : "names",radio : "names" , words : "names"}
    fileWordsOptionArray.value.push(oneDisplay)
    fileWordsOptionDisplayWordsArray.push(oneDisplay.words)
    oneDisplay = { index : 2, name : translateEnglishWords("Letters") + ": a, b, ...", id : "letters",radio : "letters" , words : "letters"}
    fileWordsOptionArray.value.push(oneDisplay) 
    fileWordsOptionDisplayWordsArray.push(oneDisplay.words)

    fileWordsOptionSelected.value = connectionStore.getFileWords
    useFileWordsOptionDisplayWords = buildWordListFromChoiceList(fileWordsOptionDisplayWordsArray)
   
    for (var i=0; i < fileWordsOptionArray.value.length; i++)
      if (fileWordsOptionSelected.value == fileWordsOptionArray.value[i].radio) {
        fileWordString.value = fileWordsOptionArray.value[i].name
        break
      }
  }

  function doFileWords() {
    //console.log("in do fileWords")
    //console.log("****************** single option array",fileWordsOptionArray.value)
    //console.log("****************** single option word list",useFileWordsOptionDisplayWords)
    //console.log("****************** selected ",fileWordsOptionSelected.value)
    wordlist.value = useFileWordsOptionDisplayWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
    toolbarTrigger.value++
    showState.value = SHOW_FILEWORDS
  }

  function boardColorsOptionClick(selected) {
    const oneValue = boardColorsOptionArray.value[selected]
    //console.log("one board color",oneValue)

    connectionStore.setBoardColors(oneValue.radio)
    boardColorsOptionSelected.value = oneValue.radio
    boardColorString.value = oneValue.name
  }

  function coordinatesOptionClick(selected) {
    const oneValue = coordinatesOptionArray.value[selected]
    //console.log("one coordinates",oneValue)

    connectionStore.setCoordinateLocation(oneValue.radio)
    coordinatesOptionSelected.value = oneValue.radio
    setCoordinateValueOnServer("coordinate",oneValue.radio)
    coordinateLocationString.value = oneValue.name
  }

   function fileWordsOptionClick(selected) {
    const oneValue = fileWordsOptionArray.value[selected]
    //console.log("one file word",oneValue)

    connectionStore.setFileWords(oneValue.radio)
    fileWordsOptionSelected.value = oneValue.radio
    fileWordString.value = oneValue.name
  }

   function fileWordsOptionToolbarClick(selected) {
    //console.log("file words option toolbar click",selected)
    toolbarTrigger.value++
    switch (selected) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "explain" :
        explainTourInitialize("options_single",null)
        break
      case "done" :
        showState.value = SHOW_MENU
        wordlist.value = wordlistMenu
        emit("word-list",wordlist.value)
        wordlistTrigger.value++
        toolbarTrigger.value++
        break
    }
  }

  function coordinatesOptionToolbarClick(selected) {
    //console.log("file words option toolbar click",selected)
    toolbarTrigger.value++
    switch (selected) {
      case "mute" :
        microphoneIsMuted.value = true 
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "explain" :
        explainTourInitialize("options_single",null)
        break
      case "done" :
        showState.value = SHOW_MENU
        wordlist.value = wordlistMenu
        emit("word-list",wordlist.value)
        wordlistTrigger.value++
        toolbarTrigger.value++
        break
    }
  }

  function toolbarClick(arrayIndex) {
    if (arrayIndex == 0)
      processWords("command done")
    else
      processWords("command explain")
  }

function processWords(text) {
  //console.log("text in Account Menu ",text)

  var returnArray = []

  switch (showState.value) {
    case SHOW_COORDINATES :
      coordinatesOptionWordsSpoken.value = text
      coordinatesOptionWordsSpokenTrigger.value++
      break
    case SHOW_BOARD_COLORS :
      boardColorsOptionWordsSpoken.value = text
      boardColorsOptionWordsSpokenTrigger.value++
      break
    case SHOW_FILEWORDS :
      fileWordsOptionWordsSpoken.value = text
      fileWordsOptionWordsSpokenTrigger.value++
      break
    case SHOW_EXPLAINTOUR :
      explainTourWordsSpoken.value = text
      explainTourWordsSpokenTrigger.value++
      break;
    case SHOW_MENU :
      returnArray = parseWordsSaid(text,parseMenuCommands)
      //console.log("menu command found",returnArray)
      switch (returnArray[0]) {
        case "scroll" :
          scrollElement("board-menu",returnArray[1])
          break
        case "explain" :
          explainTourInitialize("board_menu",null)
          break
        case "mute" :
          microphoneIsMuted.value = true 
         emit("mic-is-muted",microphoneIsMuted.value)
         connectionStore.setMicrophoneIsMuted(true)
          break
        case "listen" :
          microphoneIsMuted.value = false 
          emit("mic-is-muted",microphoneIsMuted.value)
          connectionStore.setMicrophoneIsMuted(false)
          break
        case "done" :
          emit("where-next","/accountmenu")
          //router.replace({ path: "/"})
          break
        case "boardcolors" :
          onClick("list","boardcolors")
          break
        case "coordinates" :
          onClick("list","coordinates")
          break
        case "filewords" :
          onClick("list","filewords")
          break
      }
      break
  }
}
  
function parseMenuCommands(words,currentWordIndex) {
  
  //console.log("in parse menu commands",words,currentWordIndex)
  var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
  var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
  var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

  for (var i = 0; i < words.length; i++) {
      if (currentWord == "ignore" || currentWord == "explain" || currentWord == "done" 
              || currentWord == "mute" || currentWord == "listen")
          return [currentWord,""];
      if (currentWord == "scroll") {
          if (nextWord == "up") {
              return ["scroll", "up"]
          }
          if (nextWord == "down") {
              return ["scroll", "down"]
          }
      }
      if (currentWord == "board" && (nextWord == "coordinate" || nextWord == "coordinates"))
        return ["coordinates",""]
      if (currentWord == "board" && (nextWord == "color" || nextWord == "colors"))
        return ["boardcolors",""]
      if (currentWord == "file")
        return ["filewords",""]
      currentWord = nextWord;
      nextWord = nextNextWord;
      nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
  }
  return ["ignore",""];
}

function parseCoordinateCommands(words,currentWordIndex) {
  
  //console.log("in parse coordinate commands",words,currentWordIndex)
  var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
  var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
  var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

  //console.log("**** SHOWSTATE",showState.value)
  for (var i = 0; i < words.length; i++) {
      if (currentWord == "ignore" || currentWord == "explain" || currentWord == "done")
          return [currentWord,""];

      if (currentWord == "inside")
        return ["in",""]
      if (currentWord == "outside")
        return ["out",""]
      if (currentWord == "none")
        return ["none",""]

      currentWord = nextWord;
      nextWord = nextNextWord;
      nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
  }
  return ["ignore",""];
}

function parseBoardColorsCommands(words,currentWordIndex) {
  
  //console.log("in parse commands",words,currentWordIndex)
  var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
  var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
  var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

  //console.log("**** SHOWSTATE",showState.value)
  for (var i = 0; i < words.length; i++) {
    if (currentWord == "ignore" || currentWord == "explain" || currentWord == "done")
          return [currentWord,""];
    if (currentWord == "light")
      return ["light",""]
    if (currentWord == "lee" && nextWord == "chess")
      return ["lichess",""]
    if (currentWord == "night" && nextWord == "time")
      return ["chessvis",""]

      currentWord = nextWord;
      nextWord = nextNextWord;
      nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
  }
  return ["ignore",""];
}

function parseFileWordsCommands(words,currentWordIndex) {
  
  //console.log("in parse coordinate commands",words,currentWordIndex)
  var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
  var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
  var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

  //console.log("**** SHOWSTATE",showState.value)
  for (var i = 0; i < words.length; i++) {
      if (currentWord == "ignore" || currentWord == "explain" || currentWord == "done" ||
              currentWord == "cancel" || currentWord == "terms")
          return [currentWord,""];

      if (currentWord == "letters")
        return ["letters",""]
      if (currentWord == "words")
        return ["words",""]
      if (currentWord == "names")
        return ["names",""]

      currentWord = nextWord;
      nextWord = nextNextWord;
      nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
  }
  return ["ignore",""];
}

// coordinate value is stored on server
function processCoordinateJsonResponse (json) {
  //console.log(" in callback",json)
  if (json.hasOwnProperty('error')) {
    explainTourInitialize(null,"ERROR:" + generateErrorAlertText(json))
    return;
  }

  const currentCoordinate = json["coordinate_initial"]
  if (currentCoordinate == "in" || currentCoordinate == "out" || currentCoordinate == "none")
      connectionStore.setCoordinateLocation(currentCoordinate)
  doCoordinates();
}

function getCoordinateValueFromServer() {
  var formData = { }
  useGetData("get_verbal_account_preferences.php", formData, processCoordinateJsonResponse)
}

 function processSetOptionJsonResponse (json) {
    //console.log(" in set option callback",json)
    if (json.hasOwnProperty('error')) {
      explainTourInitialize(null,"ERROR:" + generateErrorAlertText(json))
      return;
    }
  }

  function setCoordinateValueOnServer(fieldName,value) {
    var formData = {
      name : fieldName,
      value : value
    }

    //console.log("Set Option ",formData)
    useGetData("set17_verbal_lichess_options_ios.php", formData,processSetOptionJsonResponse)
  }

</script>

<style scoped>

ion-label {
    cursor: pointer;
 }

.indent {
  margin-left : 40px;
  font-style: italic;
 }

</style>